import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as customControlActions from 'actions/customControlActions';

const mapStateToProps = state => ({
  customControlState: state.customControl,
});

const mapDispatchToProps = dispatch => ({
  customControlActionsBound: bindActionCreators(customControlActions, dispatch),
});

export function withCustomControl(WrappedComponent) {
  return class CustomControlWrapperLayout extends Component {
    static propTypes = {
      customControlState: PropTypes.shape({
        token: PropTypes.string,
      }).isRequired,
      customControlActionsBound: PropTypes.shape({
        showControl: PropTypes.func.isRequired,
      }).isRequired,
    };

    state = {
      customControlToken: null,
    };

    onShowCustomControl = () => {
      const token = Math.random().toString();
      this.setState({
        customControlToken: token,
      });

      this.props.customControlActionsBound.showControl({
        token,
      });
    };

    onHideCustomControl = () => {
      this.setState({ customControlToken: null });
    };

    render() {
      const { customControlState } = this.props;

      const stateToken = this.state.customControlToken;
      const storeToken = customControlState.token;

      const isCustomControlVisible = (stateToken === storeToken) && stateToken !== null;
      const wrappedComponentProps = {
        isCustomControlVisible,
        showCustomControl: this.onShowCustomControl,
        hideCustomControl: this.onHideCustomControl,
      };

      return <WrappedComponent {...wrappedComponentProps} {...this.props} />;
    }
  };
}

const wrapWithCustomControl = wrappedComponent => connect(mapStateToProps, mapDispatchToProps)(withCustomControl(wrappedComponent));

export default wrapWithCustomControl;



/** WEBPACK FOOTER **
 ** ./src/layouts/CustomControlLayout/CustomControlWrapperLayout.jsx
 **/